import React from "react";
import ExperienceFooter from "../ExperienceFooter";
import "./Disclaimer.css";
// import Navbar from "../homePage/Navbar";
// import Footer from "../homePage/Footer";

const Disclaimer = () => {
  return (
    <div className="disclaimer-container">
      {/* <Navbar /> */}
      <div className="disclaimer-content">
        <div className="disclaimer-title-center">
          <h1 className="disclaimer-title">
            Disclaimer for Propviz Technology Private Limited
          </h1>
        </div>
        <div>
          <h3 className="disclaimer-heading">
            General Information
          </h3>
          <div className="disclaimer-padding">
            The information contained on this website and in our services is for
            general information purposes only. While we endeavor to keep the
            information up to date and correct, we make no representations or
            warranties of any kind, express or implied, about the completeness,
            accuracy, reliability, suitability, or availability with respect to
            the website or the information, products, services, or related
            graphics contained on the website for any purpose.
          </div>
        </div>
        <div>
          <h3 className="disclaimer-heading">
            Virtual Reality and 3D Content
          </h3>
          <div className="disclaimer-padding">
            All virtual reality tours, 3D renders, video walkthroughs, and
            digital representations provided through our services are for
            illustrative and marketing purposes only. These digital
            representations may not accurately reflect the final, as-built
            condition of any property, project, or development. Actual
            specifications, dimensions, finishes, colors, materials, and
            features may vary from the digital representations.
          </div>
        </div>
        <div>
          <h3 className="disclaimer-heading">
            No Warranty
          </h3>
          <div className="disclaimer-padding">
            Any reliance you place on such information is therefore strictly at
            your own risk. In no event will Propviz Technology Private Limited
            be liable for any loss or damage including without limitation,
            indirect or consequential loss or damage, or any loss or damage
            whatsoever arising from loss of data or profits arising out of, or
            in connection with, the use of this website or our services.
          </div>
        </div>
        <div>
          <h3 className="disclaimer-heading">
            Real Estate Information
          </h3>
          <div className="disclaimer-padding">
            All property information, pricing, availability, specifications, and
            other details displayed through our services are provided by third
            parties (builders, developers, real estate agents, etc.) and are
            subject to change without notice. We do not guarantee the accuracy,
            completeness, or timeliness of any property information. All
            property transactions should be verified independently with the
            respective property owners, builders, or authorized representatives.
          </div>
        </div>
        <div>
          <h3 className="disclaimer-heading">
            External Links
          </h3>
          <div className="disclaimer-padding">
            Through this website, you are able to link to other websites which
            are not under the control of Propviz Technology Private Limited. We
            have no control over the nature, content, and availability of those
            sites. The inclusion of any links does not necessarily imply a
            recommendation or endorse the views expressed within them.
          </div>
        </div>
        <div>
          <h3 className="disclaimer-heading">
            Technical Limitations
          </h3>
          <div className="disclaimer-padding">
            Our services may be subject to technical limitations, including but
            not limited to internet connectivity, device compatibility, browser
            requirements, and software dependencies. We do not guarantee
            uninterrupted or error-free access to our services. We reserve the
            right to modify, suspend, or discontinue any part of our services at
            any time without prior notice.
          </div>
        </div>
        <div>
          <h3 className="disclaimer-heading">
            Professional Advice
          </h3>
          <div className="disclaimer-padding">
            The information provided through our services does not constitute
            legal, financial, real estate, or professional advice. You should
            consult with qualified professionals (lawyers, financial advisors,
            real estate agents, etc.) before making any decisions based on
            information obtained through our services.
          </div>
        </div>
        <div>
          <h3 className="disclaimer-heading">
            Limitation of Liability
          </h3>
          <div className="disclaimer-padding">
            To the fullest extent permitted by applicable law, Propviz
            Technology Private Limited, its directors, employees, agents, and
            affiliates shall not be liable for any direct, indirect,
            incidental, special, consequential, or punitive damages, or any loss
            of profits or revenues, whether incurred directly or indirectly, or
            any loss of data, use, goodwill, or other intangible losses,
            resulting from your use of or inability to use our services.
          </div>
        </div>
        <div>
          <h3 className="disclaimer-heading">
            Indemnification
          </h3>
          <div className="disclaimer-padding">
            You agree to indemnify, defend, and hold harmless Propviz Technology
            Private Limited and its officers, directors, employees, agents, and
            affiliates from and against any and all claims, damages, obligations,
            losses, liabilities, costs, or debt, and expenses (including
            attorney's fees) arising from your use of our services or violation
            of any terms and conditions.
          </div>
        </div>
        <div>
          <h3 className="disclaimer-heading">
            Changes to Disclaimer
          </h3>
          <div className="disclaimer-padding">
            We reserve the right to update, change, or replace any part of this
            Disclaimer at any time. It is your responsibility to check this page
            periodically for changes. Your continued use of or access to our
            services following the posting of any changes constitutes acceptance
            of those changes.
          </div>
        </div>
        <div>
          <h3 className="disclaimer-heading">
            Contact Information
          </h3>
          <div className="disclaimer-padding">
            If you have any questions about this Disclaimer, please contact us
            at:
            <div>
              <span className="disclaimer-semibold">Email:</span> hi@convrse.ai
            </div>
            <div>
              <span className="disclaimer-semibold">Phone:</span> +91 8473994822
            </div>
            <div>
              <span className="disclaimer-semibold">Address:</span> Gurgaon
            </div>
          </div>
        </div>
      </div>
      <ExperienceFooter />
      {/* <Footer /> */}
    </div>
  );
};

export default Disclaimer;